import { Tooltip } from '@heroui/react';
import React from 'react';
import { FiInfo } from 'react-icons/fi';

export interface InfoTooltipProps {
  /** What the tooltip is about, for people using a screen reader. */
  label: string;
  paragraphs: string[];
}

/** An information icon carrying a few sentences of plain explanation. */
export const InfoTooltip: React.FC<InfoTooltipProps> = ({
  label,
  paragraphs,
}) => (
  <Tooltip
    content={
      <div className="max-w-xs space-y-2 p-1 text-xs normal-case">
        {paragraphs.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </div>
    }
  >
    <span className="cursor-help text-default-400" aria-label={label}>
      <FiInfo className="h-3.5 w-3.5" />
    </span>
  </Tooltip>
);

export interface ColumnLabelProps {
  label: string;
  paragraphs: string[];
}

/** A table column heading with an explanation behind an information icon. */
export const ColumnLabel: React.FC<ColumnLabelProps> = ({
  label,
  paragraphs,
}) => (
  <span className="flex items-center gap-1.5">
    {label}
    <InfoTooltip label={`What ${label} means`} paragraphs={paragraphs} />
  </span>
);
